export interface ICasesSelectStateModel {
  nextCaseId: null | number;
  prevCaseId: null | number;
}

export const CASES_SELECT_INITIAL_STATE: ICasesSelectStateModel = {
  nextCaseId: null,
  prevCaseId: null,
};
